import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { ITenure } from "src/domain/entities"
import { tenureDeleteService } from "src/domain/services/tenure/tenureDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	tenure: ITenure
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const TenureDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	tenure,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleTenureDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await tenureDeleteService({ id: tenure.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [tenure, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Tenure: ${tenure.term.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleTenureDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
